import getConfig from 'next/config';
import { getCookie, getTokenFromCookies } from '../../hooks/useCookie';
import getCarts from '../../integration/cart.api';
import {
  getHandsets,
  getHandset,
  addHandset,
  // removeHandset,
  addEquipment,
  removeEquipment,
} from '../../integration/handset.api';

const { publicRuntimeConfig } = getConfig();

// To add a cart when
export const addHandsetToCart = async ({ graphql, localStorage, catalogCode, offerId, cart }) => {
  try {
    if (getCookie('cart_Type') === 'CHANGE_OFFER' || getCookie('cart_Type') === 'CROSS_SELL') {
      if (localStorage.hasValue('REF') || getCookie('reference')) {
        const data = await addEquipment({
          graphql,
          variables: {
            reference: localStorage.getLocalStorage('REF') || getCookie('reference'),
            catalogCode,
            offerId,
            equipments: cart?.offers
              ?.filter(offer => offer?.id === offerId)[0]
              ?.equipments?.map(eq => eq.id),
            cartType: getCookie('cart_Type'),
            token: getTokenFromCookies(),
            type: 'HANDSET',
          },
        });
        if (data) {
          /*  *****Temporary Fix******** */
          /* Since CART_SCHEMA and reponse from addEquipment schema are differnt ,hence calling getCart to match the schema */
          let reqParam = {};
          reqParam = {
            token: getTokenFromCookies(),
            cartType: getCookie('cart_Type'),
            reference: localStorage.getLocalStorage('REF') || getCookie('reference'),
          };
          if (!getCookie('cart_Type')) delete reqParam.cartType;
          const { getCart: cartData } = await getCarts({ graphql, variables: reqParam });
          return { cart: cartData };
        }
      }
    } else {
      const { addMobileHandset: cartData } = await addHandset({
        graphql,
        variables: {
          prospectUuid: localStorage.getLocalStorage('PROSPECTUUID') || getCookie('reference'),
          catalogCode,
          offerId,
          equipments: cart?.offers
            ?.filter(offer => offer.id === offerId)[0]
            ?.equipments?.map(eq => eq.id),
          // eslint-disable-next-line
          portIn: getCookie('PREPAY_STANDALONE_PORTIN') === 'true' ? true : false,
        },
      });
      return { cart: cartData };
    }
  } catch (error) {
    console.error(error);
    return { error };
  }
};

// To remove a cart on unselecting add button.
export const removeHandsetFromCart = async ({ graphql, localStorage, offerId, equipmentId }) => {
  try {
    if (localStorage.hasValue('REF')) {
      const { removeEquipment: cartData } = await removeEquipment({
        graphql,
        variables: {
          reference: localStorage.getLocalStorage('REF'),
          cartType: getCookie('cart_Type'),
          token: getTokenFromCookies(),
          offerId,
          equipmentId,
        },
      });
      return { cart: cartData };
    }

    // } else {
    //   const variables = {
    //     offerId,
    //     prospectUuid: localStorage.getLocalStorage('PROSPECTUUID'),
    //     equipmentId,
    //   };
    //   if (localStorage.hasValue('PROSPECTUUID')) {
    //     const data = await removeHandset({
    //       graphql,
    //       variables,
    //     });
    //     return { cart: data.removeMobileHandset };
    //   }
    //   return { error: 'No mobile handset found in cart.' };
    // }
  } catch (error) {
    console.error(error);
    return { error };
  }
};

export const convertCentToEuro = price => {
  let euro = NaN;
  if (Number.isInteger(price)) {
    euro = (price / 100).toLocaleString('en-IE', {
      style: 'currency',
      currency: 'EUR',
    });
  }
  return euro;
};

export const handsetJourney = async ({ graphql, equipmentName }) => {
  // call getHandsets to get prospect id and offerId
  // save prospectid in localstorage
  // set variables
  let variable = {};
  variable = {
    offerType: 'POSTPAY',
    token: getTokenFromCookies(),
    cartType: getCookie('cart_Type'),
    reference: getCookie('reference'),
  };
  if (!getCookie('cart_Type')) delete variable.cartType;
  const { getHandsets: handsets } = await getHandsets({
    graphql,
    variables: variable,
  });
  const { getHandset: handsetInfo } = await getHandset({
    graphql,
    variables: {
      equipmentName,
      reference: handsets.reference,
      cartOfferID: handsets.cartOfferID,
      token: getTokenFromCookies(),
      cartType: getCookie('cart_Type'),
    },
  });
  const { getCart: cart } = await getCarts({
    graphql,
    variables: {
      reference: handsets.reference,
      token: getTokenFromCookies(),
      cartType: getCookie('cart_Type'),
    },
  });

  return { handsetInfo, cart, isHandsetJourney: true };
};

export const onload = async ({ graphql, localStorage, equipmentName, router }) => {
  try {
    let result = {
      handsetInfo: null,
      cart: {},
      isHandsetJourney: false,
      isHandsetAlreadyInCart: false,
    };
    const ref =
      localStorage.getLocalStorage('prospectuuid') ||
      localStorage.getLocalStorage('REF') ||
      getCookie('reference');
    // if prospect not availbale in localStorage, it's a  handset journey
    if (
      !localStorage.hasValue('prospectuuid') &&
      !localStorage.hasValue('ref') &&
      !getCookie('reference')
    ) {
      // result = { ...result, ...(await handsetJourney({ graphql, equipmentName })) };
      router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/redirectSummary`);
    } else {
      let reqParam = {};
      reqParam = {
        token: getTokenFromCookies(),
        cartType: getCookie('cart_Type'),
        reference: ref,
      };
      if (!getCookie('cart_Type')) delete reqParam.cartType;
      const { getCart: cart } = await getCarts({ graphql, variables: reqParam });
      const mobileOffer = cart?.offers.filter(offer => offer.baseOffer.serviceGroup === 'MOBILE');

      // else, if no mobile offer in the cart, it's a  handset journey
      if (mobileOffer.length === 0) {
        router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/redirectSummary`);
        // result = { ...result, ...(await handsetJourney({ graphql, equipmentName, prospectUuid })) };
      }
      // else, its a mobile journey
      else {
        const offerId =
          Boolean(localStorage.hasValue('ENABLE_MULTI_OFFERS')) && mobileOffer.length > 1
            ? mobileOffer[1].id
            : mobileOffer[0].id;
        // get offer id of the mobile offer (BILLPAY) in cart, based on ENABLE_MULTI_OFFERS in localstorage.
        let variable = {};
        variable = {
          token: getTokenFromCookies(),
          cartType: getCookie('cart_Type'),
          reference:
            getCookie('reference') ||
            localStorage.getLocalStorage('prospectuuid') ||
            localStorage.getLocalStorage('REF'),
          equipmentName,
          cartOfferID: offerId,
        };
        if (!getCookie('cart_Type')) delete variable.cartType;

        // get handset with offerId in cart and prospect in localstorage
        const { getHandset: handset } = await getHandset({
          graphql,
          variables: variable,
        });
        // check for equipment in offer in cart
        const selectedhanset = handset.handset.variants.filter(
          variant => variant.code === mobileOffer[0].equipments.catalogCode
        );

        result = {
          ...result,
          handsetInfo: handset,
          isHandsetAlreadyInCart: selectedhanset.length > 0,
        };
      }
      result = { ...result, cart };
    }
    return result;
  } catch (error) {
    console.error(error);
    return { error };
  }
};
